<template>
  <div class="dashboard">
    <v-gallery :images="images" :index="index" @close="index = null" />
    <v-container class="pa-0">
      <v-overlay :value="overlay">
        <v-progress-circular
          color="primary"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <GmapMap
        :center="center"
        :zoom="zoom"
        map-type-id="terrain"
        style="height:100vh; "
        :options="{
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          styles: this.mapStyle,
        }"
      >
        <GmapCluster :maxZoom="15" :zoomOnClick="true">
          <!-- <Gmap-Marker
						v-for="data in staffList"
						:key="data.id"
						:position="{ lat: data.lat, lng: data.lng }"
						:clickable="true"
						@click="toggleInfo(data, data.id)"
					></Gmap-Marker> -->

          <gmap-custom-marker
            v-for="data in staffList"
            :key="data.id"
            :marker="{ lat: data.lat, lng: data.lng }"
            :clickable="true"
            @click.native="toggleInfo(data, data.id)"
          >
            <v-avatar class="mx-2" v-if="data.face_url == null"></v-avatar>
            <v-avatar size="40" class="mx-2" v-else>
              <v-img
                style="cursor: pointer;"
                :src=" data.face_url != null && data.face_url != '-'
                      ? data.face_url
                      : 'img/neutral.svg'"
                      lazy-src="img/neutral.svg"
                alt="Avatar"
                class="portrait"
              />
            </v-avatar>
          </gmap-custom-marker>

          <GmapInfoWindow
            :options="info_options"
            :position="info_position"
            :opened="info_opened"
            @closeclick="onCloseIW"
          >
          </GmapInfoWindow>
        </GmapCluster>
      </GmapMap>
    </v-container>
    <img
      src="img/btn-filter.png"
      alt="filter"
      class="btn-fliter"
      @click="onClickFilter"
    />
    <v-container class="container-filter" v-if="showFilter">
      <v-card>
        <v-card-title>
          {{$t('filter_data')}}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col md="6" class="pb-0 pt-0 ">
              <v-combobox
                :label="$t('time')"
                :items="timeList"
                v-model="filterTime"
                item-text="name"
                item-value="value"
              ></v-combobox>
            </v-col>
            <v-col md="6" class="pb-0 pt-0 ">
              <v-combobox
                :label="$t('zone')"
                :items="zoneList"
                v-model="filterZone"
                item-text="name"
                item-value="value"
              ></v-combobox>
            </v-col>
            <v-col md="12" class="pb-0 pt-0">
              <v-combobox
                :label="$t('place')"
                :items="placeList"
                v-model="filterPlace"
                item-text="name"
                item-value="value"
              ></v-combobox>
            </v-col>
            <v-col md="12" class="pb-0 pt-0 ">
              <v-combobox
                :label="$t('group')"
                :items="groupList"
                v-model="filterGroup"
                item-text="name"
                item-value="value"
              ></v-combobox>
            </v-col>

            <v-col md="12" class="pb-0 pt-0">
              <v-menu
                ref="menuStartDate"
                v-model="menuStartDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateStartFormatted"
                    :label="$t('select_date')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    color="primary"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  @change="onDateChange()"
                  :locale="$t('locale')"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-btn block outlined color="#033B6D" @click="onSearchFilter">
           {{$t('search')}}
          </v-btn>
          <!-- <v-btn class="mt-2 white--text" block color="#033B6D">
            Download Report
          </v-btn> -->
        </v-card-text>
      </v-card>
    </v-container>
    <v-container class="container-summary">
      <div v-if="this.isHistoryClick == true"></div>
      <div v-else>
        <v-card class="pl-5">
          <v-row>
            <v-col md="12 pb-1">
              <span class="color-primary font-weight-bold label-summary"
                >{{$t('summary')}}</span
              >
            </v-col>
            <v-col md="4" class="pt-0 px-0">
              <div class="d-flex">
                <img
                  src="img/ic-ontime.png"
                  alt="ontime"
                  class="my-auto mr-1"
                  height="30"
                />

                <div class="d-flex flex-column">
                  <span class="tiny-text">{{$t('on_time')}}</span>
                  <span class="color-primary">{{ this.countOntime }}</span>
                </div>
              </div>
            </v-col>
            <v-col md="4" class="pt-0 px-0">
              <div class="d-flex">
                <img
                  src="img/ic-intolerance.png"
                  alt="in tolerance"
                  class="my-auto mr-1"
                  height="30"
                />

                <div class="d-flex flex-column">
                  <span class="tiny-text">{{$t('in_tolerance')}}</span>
                  <span class="color-primary">{{ this.countInTolerance }}</span>
                </div>
              </div>
            </v-col>
            <v-col md="4" class="pt-0 px-0">
              <div class="d-flex">
                <img
                  src="img/ic-late.png"
                  alt="late"
                  class="my-auto mr-1"
                  height="30"
                />
                <div class="d-flex flex-column">
                  <span class="tiny-text">{{$t('late')}}</span>
                  <span class="color-primary">{{ this.countOnLate }}</span>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-container>

    <v-container class="container-content">
      <v-card :loading="loading" class="content-card px-3 overflow-y-auto">
        <div v-if="this.isHistoryClick == true">
          <v-row class="pt-6">
            <v-col class="md-12">
              <v-menu
                ref="menuStartPeriode"
                v-model="menuStartPeriode"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateStartPeriode"
                    :label="$t('start_date')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    color="primary"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="periodeStart"
                  @change="onStartDateChange"
                  no-title
                  :locale="$t('locale')"
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="md-12">
              <v-menu
                ref="menuEndPeriode"
                v-model="menuEndPeriode"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateEndPeriode"
                    :label="$t('end_date')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    color="primary"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="periodeEnd"
                  @change="onEndDateChange"
                  :locale="$t('locale')"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <v-row>
            <v-col md="12">
              <v-text-field
                :label="$t('search_employee_name')"
                prepend-icon="mdi-magnify"
                append-icon="mdi-close"
                :rules="[validator.alfaNumberNotRequired]"
                @click:append="resetSearchEmployee"
                single-line
                v-model="search_string"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col
            md="12"
            v-for="staff in isHistoryClick ? staffFilteredList : filteredList"
            :key="staff.id"
          >
            <div @click="focusUser(staff)" class="d-flex">
              <v-avatar
                @click="
                  if (staff.face_url != null && staff.face_url != '-') {
                    index = parseInt(staff.index);
                    images = [staff.face_url];
                  }
                "
                size="40"
                class="mx-2"
              >
                <v-img
                  :src="
                    staff.face_url != null && staff.face_url != '-'
                      ? staff.face_url
                      : 'img/neutral.svg'
                  "
                  lazy-src="img/neutral.svg"
                  alt="Avatar"
                />
              </v-avatar>
              <div class="d-flex flex-column">
                <div>
                  <b>{{ staff.full_name }}</b>
                  {{ checkType(staff.type) }}

                  <v-tooltip
                    top
                    :color="checkReasonColorBg(staff.reason)"
                    v-if="checkReasonForShowTooltip(staff.reason)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind:class="checkReasonColor(staff.reason)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ staff.reason }}
                      </span>
                    </template>
                    <span>{{ reasonChecker(staff.reason_user) }}</span>
                  </v-tooltip>

                  <span v-else v-bind:class="checkReasonColor(staff.reason)">
                    <span v-if="staff.reason != 'Checked-Out'">
                       <span style="color: black !important;"> | </span> {{$t(staff.reason.toLowerCase())}}
                    </span>
                  </span>
                </div>
                <div>
                  {{ staff.date + " | " + toHours(staff.timezone, staff.time) + '&nbsp;' + checkTimeZone(staff.timezone) }}.

                  <v-tooltip
                    top
                    :color="checkNoteColorBg(staff.note)"
                    v-if="staff.note != 'In-Area'"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind:class="checkNoteColor(staff.note)"
                        v-bind="attrs"
                        v-on="on"
                        >{{$t('out_zone')}}</span
                      >
                    </template>
                    <span>{{reasonChecker(staff.note_user)}}</span>
                  </v-tooltip>

                  <span v-else v-bind:class="checkNoteColor(staff.note)"
                    >{{$t('in_zone')}}</span
                  >
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import mt from "moment-timezone";

export default {
  name: "dashboard-attendance",
  data() {
    return {
      firstload: true,
      staffListTmp: [],
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      company_id: this.$store.state.company,
      showFilter: false,
      places: null,
      center: { lat: -6.1753924, lng: 106.8249641 },
      zoom: 12,
      info_marker: null,
      info_position: null,
      info_content: null,
      info_opened: false,
      info_current_key: null,
      info_options: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
        content: "",
      },
      markers: [],
      filterTime: "",
      filterZone: "",
      filterPlace: "",
      filterGroup: "",
      filterDate: "",
      search_string: "",
      startDate: new Date().toISOString().substr(0, 10),
      beforeDate: moment().format("DD-MM-YYYY"),
      countOntime: 0,
      countInTolerance: 0,
      countOnLate: 0,
      addItem: {
        id: "",
        zonename: "",
        address_zone: "",
        lat_zone: "",
        lng_zone: "",
        radius: "",
        companyId: "",
      },
      timeList: [
        { name: this.$i18n.t('all_time'), value: "" },
        { name: this.$i18n.t('on_time'), value: "On-Time" },
        { name: this.$i18n.t('in_tolerance'), value: "In-Tolerance" },
        { name: this.$i18n.t('late'), value: "late" },
      ],
      zoneList: [
        { name: this.$i18n.t('all_area'), value: "" },
        { name: this.$i18n.t('in_zone'), value: "inzone" },
        { name: this.$i18n.t('out_zone'), value: "outzone" },
      ],
      staffListInit: [],
      staffList: [],
      staffFilteredList: [],
      isHistoryClick: false,
      groupList: [],
      menuStartDate: false,
      menuEndPeriode: false,
      menuStartPeriode: false,
      user_late: 0,
      user_intolerance: 0,
      user_ontime: 0,
      marker: null,
      mapStyle: [
        {
          featureType: "poi",
          stylers: [{ visibility: "off" }],
        },
      ],
      periodeStart: "",
      periodeEnd: "",
      index: null,
      images: [],
      user_id: this.$store.state.user.id,
      new_data: [],
      loading: true,
      overlay: true,
      selectedUser: null,
    };
  },
  computed: {
    filteredList() {
      const search_string = this.search_string.toLowerCase();
      return this.staffList.filter((item) =>
        item.full_name.toLowerCase().includes(search_string)
      );
    },
    dateStartFormatted() {
      return this.startDate ? moment(this.startDate).locale(this.$i18n.t('lang')).format("DD MMM YYYY") : "";
    },
    dateStartPeriode() {
      return this.periodeStart
        ? moment(this.periodeStart, "YYYY-MM-DD").format("DD MMM YYYY")
        : "";
    },
    dateEndPeriode() {
      return this.periodeEnd
        ? moment(this.periodeEnd, "YYYY-MM-DD").format("DD MMM YYYY")
        : "";
    },
    avatarUrl() {
      return this.$store.state.user.avatar;
    },
    cuttOffDate() {
      return this.$store.state.cutoff_date;
    },
  },
  created() {
    this.fetchZones();
    this.fetchGroup();
    this.fetchNew();
  },
  methods: {
    dateFormatted(date) {
      return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY");
    },
    reasonChecker(reason) {
      if(reason.length === 0){
        return '-'
      } else {
        return reason
      }
    },
    focusUser(item) {
      this.center = {
        lat: parseFloat(item.lat),
        lng: parseFloat(item.lng),
      };
      this.zoom = 18;
    },
    checkType(type) {
      if (type === "in") {
        return this.$i18n.t('checkin');
      } else if (type === "out") {
        return  this.$i18n.t('checkout');
      }
    },
    checkReasonForShowTooltip(reason) {
      switch (reason) {
        case 'On-Time':
        case 'In-Tolerance':
        case 'Checked-Out':
          return false
        default: 
          return true
      }
    },
    checkReasonColor(reason) {
      if (reason === "-") {
        return;
      }
      if (reason === "On-Time") {
        return;
      } else {
        if (reason === "In-Tolerance" || reason === "Meeting") {
          return "warning--text";
        } else {
          return "error--text";
        }
      }
    },
    checkReasonColorBg(reason) {
      if (reason === "-") {
        return;
      }
      if (reason === "On-Time") {
        return;
      } else {
        if (reason === "In-Tolerance" || reason === "Meeting") {
          return "warning";
        } else {
          return "error";
        }
      }
    },
    checkNoteColor(note) {
      if (note === "In-Area") {
        return;
      } else {
        if (
          note === "GPS Error" ||
          note === "Meeting" ||
          note === "Work From Home"
        ) {
          return "error--text";
        } else {
          return "error--text";
        }
      }
    },
    checkNoteColorBg(note) {
      if (note === "In-Area") {
        return;
      } else {
        if (
          note === "GPS Error" ||
          note === "Meeting" ||
          note === "Work From Home"
        ) {
          return "error";
        } else {
          return "error";
        }
      }
    },
    setPlace(places) {
      this.addItem.lat_zone = places.geometry.location.lat();
      this.addItem.lng_zone = places.geometry.location.lng();
      this.addItem.address_zone = places.formatted_address;
      this.places = places;
      this.center = {
        lat: places.geometry.location.lat(),
        lng: places.geometry.location.lng(),
      };
    },
    onCloseIW() {
      this.info_opened = false;
      this.isHistoryClick = false;
      this.search_string = "";
    },
    onDateChange() {
      this.menuStartDate = false;
    },
    onStartDateChange() {
      this.menuStartPeriode = false;
      const startDate = moment(this.periodeStart).format('DD-MM-YYYY');
      const endDate = moment(this.periodeEnd).format('DD-MM-YYYY');
      this.fetchByUser(this.selectedUser, startDate, endDate);
    },
    onEndDateChange() {
      this.menuEndPeriode = false;
      const startDate = moment(this.periodeStart).format('DD-MM-YYYY');
      const endDate = moment(this.periodeEnd).format('DD-MM-YYYY');
      this.fetchByUser(this.selectedUser, startDate, endDate);
    },
    onClickFilter() {
      this.showFilter = !this.showFilter;
    },
    async fetchZones() {
      this.placeList = [];
      const result = await this.$store.dispatch('getZoneMasterByCompany', { companyId: this.company_id })
      result.rows.forEach((row) => {
        if(row.zonename){
        let placeList = {};
        placeList.name = row.zonename;
        placeList.value = row.id;
        this.placeList.push(placeList);
        }
      })
    },
    toHours(zone, time) {
      if (time != undefined) {
        let utc = new Date(parseInt(time));
        let tmp = "";
        if (zone === 7) {
          tmp = mt.tz(utc, "Asia/Jakarta");
        } else if (zone === 8) {
          tmp = mt.tz(utc, "Asia/Makassar");
        } else if (zone === 9) {
          tmp = mt.tz(utc, "Asia/Jayapura");
        }
        return this.convertDate(tmp);
      }
    },
     convertDate(time) {
      let convert = time.toString().split(" ");
      let hour = convert[4];
      return hour;
    },

     checkTimeZone(zone){
      if (zone === 7) {
        return 'WIB'
      } else if (zone === 8) {
        return 'WITA'
      } else if (zone === 9) {
        return 'WIT'
      }
    },
    async fetchGroup() {
      const result = await this.$store.dispatch('getGroupByCompany', { companyId: this.company_id })
      this.groupList = [];
      result.forEach((row) => {
        let groupList = {};
        groupList.name = row.alias;
        groupList.value = row.id;
        
        this.groupList.push(groupList);
      
      })
        this.groupList.unshift({ name: this.$i18n.t('all'), value: 'all' });
    },
    countSummary() {
      this.countOntime = 0;
      this.countInTolerance = 0;
      this.countOnLate = 0;

      this.staffList.forEach((data) => {
        if (data.type == "in") {
          if (data.reason == "On-Time") {
            this.countOntime++;
          } else if (data.reason == "In-Tolerance") {
            this.countInTolerance++;
          } else if (data.reason == "Others" || data.reason == "others") {
            this.countOnLate++;
          } else if (data.reason == "Meeting" || data.reason == "meeting") {
            this.countOnLate++;
          } else if (data.reason == "Incident" || data.reason == "incident") {
            this.countOnLate++;
          }
        }
      });
    },
    countSummaryUser() {
      this.user_ontime = 0;
      this.user_intolerance = 0;
      this.user_late = 0;

      this.staffFilteredList.forEach((data) => {
        if (data.type == "in") {
          if (data.reason == "On-Time") {
            this.user_ontime++;
          } else if (data.reason == "In-Tolerance") {
            this.user_intolerance++;
          } else if (data.reason == "Meeting") {
            this.user_intolerance++;
          } else if (data.reason == "Others") {
            this.user_late++;
          } else if (data.reason == "Meeting") {
            this.user_late++;
          } else if (data.reason == "Incident") {
            this.user_late++;
          }
        }
      });
    },
    async fetchNew() {
      this.loading = true;
      this.overlay = true;
      const date = moment(this.startDate).format("DD-MM-YYYY");
      const result = await this.$store.dispatch('getReportAttendanceByUser', { date, userId: this.user_id })
      this.staffListTmp = [];
      this.staffList = [];
      result.forEach((row) => {
          let staffList = {};
          if (
            this.filterTime == "" ||
            this.filterTime == null ||
            this.filterTime.value == ""
          ) {
            if(row.note_user !== "" && row.note !== ""){
            staffList.id = row.id;
            staffList.index = "99" + row.id;
            staffList.full_name = row.full_name;
            staffList.job_position = row.job_position;
            staffList.type = row.type;
            staffList.time = row.timestamp;
            staffList.timezone = row.timezone;
            staffList.note = row.note;
            staffList.note_user = row.note_user;
            staffList.reason = row.reason;
            staffList.reason_user = row.reason_user;
            staffList.groupId = row.groupId;
            staffList.lat = row.latitude;
            staffList.lng = row.longitude;
            staffList.date = moment(row.date, "DD-MM-YYYY").format(
              "DD/MM/YYYY"
            );
            staffList.face_url = row.face_url;
            staffList.zone_name = row.zone_name;
            staffList.zone_master_id = row.zone_master_id;
            staffList.avatar_url = row.avatar_url;
            staffList.userId = row.user_id;
            this.staffListTmp.push(staffList);
            this.staffList = [].concat(this.staffListTmp)
            }
          }
          this.countSummary();
      });
      this.loading = false;
      this.overlay = false;
      if (this.firstload) {
        // this.filterGroup = this.groupList.find(e => {return e.value == this.$store.state.user.detail.groupId})
        this.filterGroup = { name: this.$i18n.t('all'), value: 'all' }
        this.onSearchFilter()
      }else{
         this.filterGroup = this.groupList.find(e => {return e.value == this.filterGroup.value})
         this.onSearchFilter()

      }
    },
    resetSearchEmployee() {
      this.search_string = "";
    },
    toggleInfo(marker, key) {
      this.info_position = { lat: marker.lat, lng: marker.lng };

      const d = new Date();
      const date = d.getDate();
      const month = d.getMonth() + 1;
      const year = d.getFullYear();

      const periodeNow = moment(
        this.cuttOffDate + "-" + month + "-" + year,
        "DD-MM-YYYY"
      ).format("DD MMMM YYYY");
      const periodeBefore = moment(
        this.cuttOffDate + "-" + month + "-" + year,
        "DD-MM-YYYY"
      )
        .subtract("1", "month")
        .format("DD MMMM YYYY");
      const periodeNext = moment(
        this.cuttOffDate + "-" + month + "-" + year,
        "DD-MM-YYYY"
      )
        .add("1", "month")
        .format("DD MMMM YYYY");
      let periode;
      if (date >= this.cuttOffDate) {
        periode =
          periodeNow +
          " - " +
          moment(periodeNext, "DD MMMM YYYY")
            .subtract("1", "day")
            .format("DD MMMM YYYY");
      } else {
        periode =
          periodeBefore +
          " - " +
          moment(periodeNow, "DD MMMM YYYY")
            .subtract("1", "day")
            .format("DD MMMM YYYY");
      }
      this.info_options.content = `<div class="text-center">....</div>`;

      const periode_start = moment(
        periode.split("-")[0],
        "DD MMMM YYYY"
      ).format("DD-MM-YYYY");
      const periode_end = moment(periode.split("-")[1], "DD MMMM YYYY").format(
        "DD-MM-YYYY"
      );
      this.selectedUser = marker;
      this.fetchByUser(marker, periode_start, periode_end);

      if (this.info_current_key == key) {
        this.info_opened = !this.info_opened;
      } else {
        this.info_opened = true;
        this.info_current_key = key;
      }
    },
    generateIW(marker, periode_start, periode_end) {
      const vm = this;
      window.searchHistory = function() {
        vm.onSearchHistory(marker.full_name);
      };
      
      this.info_options.content = `
			<div style="margin-bottom:5px" class="text-center">
				<div class="v-avatar mx-2" style="height: 64px; min-width: 64px; width: 64px;">
					<v-img src="${
            marker.avatar_url != null && marker.avatar_url != '-'
                      ? marker.avatar_url
                      : 'img/neutral.svg'
          }" lazy-src="img/neutral.svg" alt="Avatar">
				</div>
			</div>
			<div style="margin-bottom:5px" class="text-center"><h3>${
        marker.full_name
      }</h3></div>
			<div class="text-center">${marker.job_position}</div>

			<div class="container" style="width:300px">
				<div class="row">
					<div class="col-md-12">
            <div class="d-flex flex-column text-center bg-primary white--text pa-2" style="border-radius:30px">
              <div white--text style="margin-bottom:5px" "> ${this.$i18n.t('period')} </div>
              <div white--text > ${periode_start} - ${periode_end} </div>
            </div>
					</div>

					<div class="col-md-4">
						<div class="d-flex flex-column text-center">
							<img style="margin-bottom:5px" src="img/ic-ontime.png" alt="ontime" class="mx-auto" height="30">
							<span style="margin-bottom:5px">${this.$i18n.t('on_time')}</span>
							<h3 class="color-primary">${this.user_ontime}</h3>
						</div>
					</div>

					<div class="col-md-4">
						<div class="d-flex flex-column text-center">
							<img style="margin-bottom:5px" src="img/ic-intolerance.png" alt="in tolerance" class="mx-auto" height="30">
							<span style="margin-bottom:5px">${this.$i18n.t('in_tolerance')}</span>
							<h3 class="color-primary">${this.user_intolerance}</h3>
						</div>
					</div>

					<div class="col-md-4">
						<div class="d-flex flex-column text-center">
							<img style="margin-bottom:5px" src="img/ic-late.png" alt="late" class="mx-auto" height="30">
							<span style="margin-bottom:5px">${this.$i18n.t('late')}</span>
							<h3 class="color-primary">${this.user_late}</h3>
						</div>
					</div>

					<div class="col-md-12">
						<button type="button" class="mt-2 white--text v-btn v-btn--block v-btn--contained theme--light v-size--default btn-search-history"
							onclick="searchHistory()"
							style="background-color: rgb(3, 59, 109); border-color: rgb(3, 59, 109);">
							<span class="v-btn__content"> ${this.$i18n.t('attendance_history')}	 </span>
						</button>
					</div>
				</div>
			</div>
			`;
    },
    onSearchHistory(fullname) {
      this.search_string = fullname;
      this.isHistoryClick = true;
    },
    async fetchByUser(data, periode_start, periode_end) {
      this.loading = true;
      this.overlay = true;
      this.periodeStart = moment(periode_start, "DD MM YYYY").format( "YYYY-MM-DD" );
      this.periodeEnd = moment(periode_end, "DD MM YYYY").format( "YYYY-MM-DD" );
      const result = await this.$store.dispatch('getReportSummaryPerUser', { userId: data.userId, tglMulai: periode_start, tglAkhir: periode_end }) 
      this.staffFilteredList = [];
       result.summaries.forEach((row) => {
          /* Checkin */
          if (row.status != "absent" && row.reason_in != null) {
            let staffFilteredList = {};
            staffFilteredList.id = "checkin" + row.id;
            staffFilteredList.full_name = data.full_name;
            staffFilteredList.job_position = data.job_position;
            staffFilteredList.type = "in";
            staffFilteredList.time = row.time_in;
            staffFilteredList.timezone = row.timezone_in;
            staffFilteredList.note = row.note_in;
            staffFilteredList.note_user = row.note_user_in;
            staffFilteredList.reason = row.reason_in;
            staffFilteredList.reason_user = row.reason_user_in;
            staffFilteredList.date = moment(row.time_in, "x").format(
              "DD/MM/YYYY"
            );
            staffFilteredList.face_url = row.face_url_in;
            staffFilteredList.avatar_url = data.avatar_url;

            this.staffFilteredList.push(staffFilteredList);
          }
          /* Checkout */
          if (row.status != "absent" && row.reason_out != null) {
            let staffFilteredList = {};
            staffFilteredList.id = "checkout" + row.id;
            staffFilteredList.full_name = data.full_name;
            staffFilteredList.job_position = data.job_position;
            staffFilteredList.type = "out";
            staffFilteredList.time = row.time_out;
            if(row.timezone_out) {
            staffFilteredList.timezone = row.timezone_out;
            } else {
               staffFilteredList.timezone = data.timezone;
            }
            staffFilteredList.note = row.note_out;
            staffFilteredList.note_user = row.note_user_out;
            staffFilteredList.reason = row.reason_out;
            staffFilteredList.reason_user = row.reason_user_out;
            staffFilteredList.date = moment(row.time_out, "x").format(
              "DD/MM/YYYY"
            );
            staffFilteredList.face_url = row.face_url_out;
            staffFilteredList.avatar_url = data.avatar_url;
 
            this.staffFilteredList.push(staffFilteredList);
          }
        });

      this.countSummaryUser();
      this.generateIW(data, periode_start, periode_end);
      this.loading = false;
      this.overlay = false;
    },
    async onSearchFilter() {
      this.firstload = false
      const date = moment(this.startDate).format("DD-MM-YYYY");
      if (date != this.beforeDate) {
        /* if date changed, get data from be */
        this.beforeDate = date
        await this.fetchNew();
      }else{
        /* if date not changed, filter data on array */
        this.filterData();
      }
    },
    filterData() {
      let filtered = [].concat(this.staffListTmp)
      const allfilter = [].concat(this.staffListTmp)

      /* Filter time */
      if (this.filterTime != "" && this.filterTime != null) {
        if (this.filterTime.value != "") {
          filtered = filtered.filter((item) => {
            if (this.filterTime.value != "late") {
              return item.reason == this.filterTime.value;
            } else {
              return item.reason != "On-Time" && item.reason != "In-Tolerance";
            }
          });
        }
      }

      /* Filter group */
      if (this.filterGroup != "" && this.filterGroup != null) {
        if (this.filterGroup.value == 'all'){
           filtered = allfilter
        }
        else if (this.filterGroup.value != "" &&  this.filterGroup.value != 'all') {
          filtered = filtered.filter(
            (item) => item.groupId == this.filterGroup.value
          );
        } 
      }

      /* Filter zone */
      if (this.filterZone != "" && this.filterZone != null) {
        if (this.filterZone.value != "") {
          filtered = filtered.filter((item) => {
            if (this.filterZone.value == "inzone") {
              return item.note == "In-Area";
            } else {
              return item.note != "In-Area";
            }
          });
        }
      }

      /* Filter place */
      if (this.filterPlace != "" && this.filterPlace != null) {
        if (this.filterPlace.value != "") {
          filtered = filtered.filter(
            (item) => item.zone_master_id == this.filterPlace.value
          );
        }
      }

      /* Set stafflist */
      this.staffList = filtered;
      this.countSummary();
    },
  },
};
</script>
<style>
.btn-fliter {
  cursor: pointer;
  position: absolute;
  top: 20px;
  left: 20px;
}
.container-filter {
  position: absolute;
  left: 0;
  top: 50px;
  width: 275px;
}
.container-summary {
  position: absolute;
  right: 0px;
  top: 10px;
  width: 350px;
}
.container-content {
  position: absolute;
  right: 0px;
  top: 105px;
  width: 350px;
  height: calc(100vh - 135px);
}
.content-card {
  font-size: 12px;
  height: calc(100vh - 135px);
}
.tiny-text {
  font-size: 9px;
  font-weight: bold;
}
.color-primary {
  color: #033b6d;
}
.bg-primary {
  background-color: #033b6d;
}
.label-summary {
  font-size: 0.7em;
}
</style>
